import React from 'react';

const TimedOutPage = ()=>{

	return "Timed Out Page";
}

export default TimedOutPage;